import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { __decorate, __metadata } from 'tslib';
import { AutoSubscription } from '@upr-web-primer/app-utils';
import * as i4 from '@upr-web-primer/gds-button-model-service';
import { GdsButtonModelService } from '@upr-web-primer/gds-button-model-service';
import * as i3 from '@upr-web-primer/gds-picture-model';
import { GdsPictureModelService } from '@upr-web-primer/gds-picture-model';
import * as i2 from '@upr-web-primer/gds-related-tile';
import { GdsRelatedTilesService } from '@upr-web-primer/gds-related-tile';
import * as i1 from '@upr-web-primer/gds-venue-tiles';
import { GdsVenueTilesService } from '@upr-web-primer/gds-venue-tiles';
import { partition, isEmpty, get } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
class GdsFullImageCardModule {
  static {
    this.ɵfac = function GdsFullImageCardModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsFullImageCardModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsFullImageCardModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFullImageCardModule, [{
    type: NgModule
  }], null, null);
})();
let GdsFullImageCardService = class GdsFullImageCardService {
  constructor(venueTiles, relatedTilesService, gdsPictureService, gdsButtonService) {
    this.venueTiles = venueTiles;
    this.relatedTilesService = relatedTilesService;
    this.gdsPictureService = gdsPictureService;
    this.gdsButtonService = gdsButtonService;
    this.items$ = new BehaviorSubject(null);
  }
  init(pagePath) {
    this.pagePath = pagePath;
    this.observeTiles();
  }
  observeTiles() {
    this.subscriptions.add(this.venueTiles.tiles$.pipe(distinctUntilChanged()).subscribe(data => {
      if (data) {
        this.getItems(data);
      }
    }));
  }
  getItems(data) {
    this.handleVenueTiles(data);
    this.handleRelatedTiles();
    const generatedItems = this.generateItems();
    return this.items$.next(generatedItems);
  }
  handleVenueTiles(data) {
    if (!data || !data.Tiles) return;
    this.pagePathRegex = new RegExp(this.pagePath, 'ig');
    this.venueTilesData = data;
    const tiles = partition(data.Tiles, tile => this.pagePathRegex.test(tile.PageUrl));
    if (tiles && !isEmpty(tiles[0])) {
      this.pageTile = tiles[0][0];
      this.tilesWithRatings = tiles[1];
    }
  }
  handleRelatedTiles() {
    this.relatedTiles = this.relatedTilesService.getRelatedTiles(this.pageTile, this.tilesWithRatings);
  }
  generateItems() {
    const items = [];
    this.relatedTiles.map(tile => {
      const bgColor = get(tile, 'Meta.CategoryLabelBackgroundColor[0].Key', '');
      const categoryLabelBackgroundColor = bgColor === 'brand-blue' ? 'blue' : bgColor;
      const image = this.gdsPictureService.initRelatedTileImage(tile.Content.TileImage);
      const link = this.gdsButtonService.initRelatedTileLink(tile);
      const item = {
        heading: get(tile, 'Content.Heading'),
        categoryLabel: get(tile, 'Content.CategoryLabel'),
        categoryLabelBackgroundColor,
        background: {
          image,
          link
        },
        eyebrow: get(tile, 'Meta.Eyebrow', ''),
        lowEyebrow: get(tile, 'Meta.LowEyebrow', '')
      };
      items.push(item);
    });
    return items;
  }
  ngOnDestroy() {
    return;
  }
  static {
    this.ɵfac = function GdsFullImageCardService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsFullImageCardService)(i0.ɵɵinject(i1.GdsVenueTilesService), i0.ɵɵinject(i2.GdsRelatedTilesService), i0.ɵɵinject(i3.GdsPictureModelService), i0.ɵɵinject(i4.GdsButtonModelService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsFullImageCardService,
      factory: GdsFullImageCardService.ɵfac,
      providedIn: 'root'
    });
  }
};
GdsFullImageCardService = __decorate([AutoSubscription(), __metadata("design:paramtypes", [GdsVenueTilesService, GdsRelatedTilesService, GdsPictureModelService, GdsButtonModelService])], GdsFullImageCardService);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsFullImageCardService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.GdsVenueTilesService
  }, {
    type: i2.GdsRelatedTilesService
  }, {
    type: i3.GdsPictureModelService
  }, {
    type: i4.GdsButtonModelService
  }], null);
})();

/*
 * Public API Surface of gds-full-image-card
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsFullImageCardModule, GdsFullImageCardService };
